export default __webpack_public_path__ + "8a25472.png";